<!-- content -->
<div class="center p-t p-b p-t-2-s p-b-2-s m-t-8">

  <!-- tags -->
  <div class="p-r-14-s p-l-14-s m-t-6 m-b">
    @for (tagCategory of tagCategories; track $index; let isFirst = $first) {
      <!-- <a class="inline-block bg-col-5 p2 p-l-2 m-b-1 p-r-2 p-a-1"
      [class.m-l-1]="!isFirst"
    [routerLink]="tagCategory.data.url">{{tagCategory.data.name}}</a> -->
    <!-- if you want to links on tags use the code above instead -->
    <span class="inline-block bg-col-5 p2 p-l-2 m-b-1 p-r-2 p-a-1"
    [class.m-l-1]="!isFirst">{{tagCategory.data.name}}</span>
  }
</div>

<!-- title -->
@if (model.data.name) {
  <h1
  class="h1 m-b-2 m-b-3-s">{{model.data.name}}</h1>
}

<!-- author -->
@if (typeData.author) {
  <div
    class="col-11 m-t">
    <span class="p1">{{'Words by' | translate}}</span>
    <span class="p1 p-l-1"
    *iCms="'author' of typeData"></span>
  </div>
}

<!-- share -->
<div class="m-t-1 m-b lh-3 col-11 m-b-12 m-b-4-s p2">
  <span translate>Share: </span>
  <button class="m-l-1 blog-header-icons"
    type="button"
    (click)="fbShare()"
    aria-label="Facebook">
    <i class="icon-facebook inline-flex"
    aria-hidden="true"></i>
  </button>
  <button class="m-l-1 blog-header-icons"
    type="button"
    (click)="pinShare()"
    aria-label="Pinterest">
    <i class="icon-pinterest inline-flex"
    aria-hidden="true"></i>
  </button>
  <button class="m-l-1 blog-header-icons"
    type="button"
    (click)="copyUrlToClipboard()"
    aria-label="CopyURL">
    <i class="icon-copy inline-flex"
    aria-hidden="true"></i>
  </button>
</div>

<!-- image -->
@if (typeData.top_image) {
  <div class="ratio-16-9-m ratio-16-9-s ratio-3-1"
    >
    <img class="rf z-1"
      [image]="typeData.top_image"
      [attr.alt]="model.data.name">
  </div>
}

<!-- component container -->
<icms-outlet [components]=" model.data.components"
  [allow]=" ['cms-blog-component-more-stories'] ">
</icms-outlet>
</div>
